// This algorithm tries to maximize alignment score
const delCost = -1;
const insCost = -1;
const replaceCost = -1;
const matchScore = 1;

const init = (rows: number, columns: number): (number[])[] => {
    // create 2D array
    const matrix = new Array<number[]>(rows);
    for(let r = 0; r < rows; r++) {
        matrix[r] = new Array<number>(columns);
    }

    // Fill base cases with zeros
    // This effectivly means we can remove or add prefix w/o penalty
    for(let r = 0; r < rows; r++) {
        matrix[r][0] = 0;
    }
    for(let c = 0; c < columns; c++) {
        matrix[0][c] = 0;
    }
    
    return matrix;
}

export const calcAlignment = (src: string, dst: string) => {
    const rows = src.length + 1;
    const columns = dst.length + 1;
    const d = init(rows, columns);

    for(let r = 1; r < rows; r++) {
        for(let c = 1; c < columns; c++) {
            const del = d[r - 1][c] + delCost;
            const ins = d[r][c - 1] + insCost;
            const repl = d[r - 1][c - 1] + ((src[r - 1] === dst[c - 1]) ? matchScore : replaceCost);

            d[r][c] = Math.max(del, ins, repl);
        }
    }

    // Take the max score on the chart(matrix) edge (right or bottom)
    // This means that we can insert or delete suffix w/o penalty
    let edgeMax = Number.NEGATIVE_INFINITY;
    for(let c = 0; c < columns; c++)
        edgeMax = Math.max(edgeMax, d[rows -1][c]);
    for(let r = 0; r < rows; r++)
        edgeMax = Math.max(edgeMax, d[r][columns -1]);
    
    return edgeMax;
}


// WEBPACK FOOTER //
// ./src/utils/string-alignment.ts